const getUrlSearchParams = (param, queryString) => {
  const searchParam = new RegExp('[?&]' + param + '=([^&#]*)').exec(queryString);
  return searchParam && decodeURI(searchParam[1]);
};

export const useShouldDisplayReferrerRecommendations = (referer, path) => {
  return /google.com|bing.com|yahoo.com|duckduckgo.com|aol.com/i.test(referer)
    || /^Shopping/i.test(getUrlSearchParams('cm_mmc', path))
    || /PIN_Shopping/i.test(getUrlSearchParams('cm_mmc', path));
};